
import { Card, CardContent } from "@/components/ui/card";

export function FreeResponseEmpty() {
  return (
    <Card>
      <CardContent className="pt-6">
        <p>No questions available for this free response activity.</p>
      </CardContent>
    </Card>
  );
}
